<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" md="3" sm="6">
        <card-widget
          icon="mdi-account-check-outline"
          label="Online"
          :value="summary.onlineCount"
        ></card-widget>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <card-widget
          icon="mdi-account-alert-outline"
          label="Offline"
          :value="summary.offlineCount"
        ></card-widget>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <card-widget
          icon="mdi-account-remove-outline"
          label="No Load"
          :value="summary.noLoad"
        ></card-widget>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <card-widget
          icon="mdi-alert-circle-check"
          label="Dormant"
          :value="summary.dormant"
        ></card-widget>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Subscribers
                  </v-toolbar-title>
                </div>
                <div class="ml-auto">
                  <small class="mr-2" v-if="loadingExport">Please wait</small>
                  <v-btn
                    color="primary"
                    class="ml-auto"
                    :loading="loadingExport"
                  >
                    <download-csv :data="exportData" :name="`${fileName}.csv`">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              @click:append="searchRecord"
              @keydown.enter.prevent="searchRecord"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :page="table.page"
            :pageCount="table.numberOfPages"
            :options.sync="options"
            :server-items-length="table.total"
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="_id"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [10, 30, 50, 100],
            }"
          >
            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <template v-slot:[`item.isPaid`]="{ item }">
              {{ item.isPaid ? "Yes" : "No" }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <ConfirmationDiaglog ref="confirm" />
  </v-container>
</template>

<script>
import moment from "moment";
import CardWidget from "../../components/CardWidget.vue";
import ShareableMethods from "@/mixins/ShareableMethods";
import ConfirmationDiaglog from "../dialogs/ConfirmationDiaglogv2.vue";
export default {
  name: "AcquisitionSubscriber",
  mixins: [ShareableMethods],
  components: {
    CardWidget,
    ConfirmationDiaglog,
  },
  data() {
    return {
      exportData: [],
      fileName: "",
      loadingExport: false,

      search: "",
      table: {
        page: 0,
        total: 0,
        numberOfPages: 0,

        // sortBy: "dtCreated",
        // sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Date Activated",
            align: "start",
            sortable: false,
            value: "activationDate",
            formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
          },

          {
            text: "Date Paid",
            align: "start",
            sortable: false,
            value: "paymentDate",
            formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
          },
          {
            text: "Province",
            align: "start",
            value: "province",
          },
          {
            text: "City",
            align: "start",
            value: "city",
          },
          {
            text: "Barangay",
            align: "start",
            value: "barangay",
          },
          {
            text: "Subscriber Name",
            align: "start",
            value: "name",
          },
          {
            text: "MobileNumber",
            align: "start",
            value: "mobileNumber",
          },
          {
            text: "Paid",
            align: "center",
            value: "isPaid",
          },

          {
            text: "Amount Paid",
            align: "center",
            value: "amountPaid",
            formatter: (x) => this.setToLocaleString(x),
          },

          {
            text: "Acquirer",
            align: "start",
            value: "acquirer",
            sortable: false,
          },
          {
            text: "Territory Head",
            align: "start",
            value: "territoryHead",
            sortable: false,
          },
          {
            text: "Status",
            align: "center",
            value: "status",
            sortable: false,
          },
          {
            text: "Load Status",
            align: "center",
            value: "loadStatus",
            sortable: false,
          },
        ],
        data: [],
      },

      options: {
        page: 1,
      },

      summary: {
        dormant: 0,
        offlineCount: 0,
        onlineCount: 0,
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList(searchVal = "") {
      this.loadingExport = true;
      this.table.loading = true;
      const { page, itemsPerPage } = this.options;
      let pageNumber = "";
      if (itemsPerPage === -1) {
        pageNumber = "";
      } else {
        pageNumber = page ? page : 1;
      }

      const perPage = itemsPerPage < 0 ? "" : itemsPerPage;

      // console.log(itemsPerPage)

      await this.$api
        .get(
          `/acquisition/report?report=activated&page=${pageNumber}&limit=${perPage}&searchVal=${searchVal}`
        )
        .then((response) => {
          const res = response.data;

          const newArr = res.data;

          if (itemsPerPage === -1) {
            this.exportTable(newArr);
          } else {
            this.table.data = newArr;
            this.table.total = res.total;
            this.table.numberOfPages = Math.ceil(res.total / itemsPerPage);
            this.exportTable(newArr);
          }

          // console.log(newArr)
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    exportTable(dataArr) {
      let exportData = dataArr.map((item) => {
        return {
          "Date Activated": item.activationDate
            ? moment(item.activationDate).format("MMMM DD, YYYY")
            : "",
          "Date Paid": item.paymentDate
            ? moment(item.paymentDate).format("MMMM DD, YYYY")
            : "",
          Province: item.province,
          City: item.city,
          Barangay: item.barangay,
          "Subscriber Name": item.name,
          "Mobile Number": item.mobileNumber,
          Paid: item.isPaid ? "Yes" : "No",
          "Amount Paid": this.setToLocaleString(item.amountPaid),
          Acquirer: item.acquirer,
          "Territory Head": item.territoryHead,
          Status: item.status,
          "Load Status": item.loadStatus,
          "JO Number": "'" + item.account.jo_no,
          SN: item.serialNumber,
          "Manual / Auto JO": item.approvedJO ? "Manual" : "Auto",
          "Account Number": item.accountNumber,
        };
      });
      this.fileName = `subscribers_list_as_of_${moment(
        moment().toDate()
      ).format("MMM_DD_YYYY")}`;
      this.exportData = exportData;
      this.loadingExport = false;
    },

    async getSubscriberSummary() {
      // this.table.loading = true;
      await this.$api
        .get("/acquisition/report?report=subscriber-summary")
        .then((response) => {
          const newArr = response.data.data;
          console.log(newArr);
          this.summary = newArr;
          // this.table.data = newArr;
          // this.table.loading = false;
        })
        .catch((e) => {
          // this.table.loading = false;
          console.log(e);
        });
    },
    searchRecord() {
      if (!this.search) {
        return;
      }

      this.getList(this.search);
    },

    async forceDownload() {
      if (
        await this.$refs.confirm.open(
          "Confirmation",
          "Can't display all the records. Would you like to download?"
        )
      ) {
        this.getList("", this.search);
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }
    },
  },
  created() {
    // console.log(this.$props.headers);
  },

  mounted() {
    this.getList();
    this.getSubscriberSummary();
  },

  watch: {
    options: {
      handler(e) {
        if (e.itemsPerPage == -1) {
          this.forceDownload();
          return;
        }
        // console.log(e);
        this.getList("", this.search);
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      },
      deep: true,
    },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
